module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-tile-3-medium-50cd22735afe7ae3175a6997d6717df0.jpg";